









































import {Component, Emit,Vue} from "vue-property-decorator";

@Component
export default class CreateApplication extends Vue {
  @Emit("close-modal")
  public closeCreateModal() {
    return "close";
  }

  @Emit("url-base-modal")
  public showUrlBaseModal() {
    return "url-base";
  }

  @Emit("rvd-base-modal")
  public showRVDBaseModal() {
    return "rvd-base";
  }
}
